<template>
  <a-form :form="form">
    <a-row :gutter="16">
      <a-form-item label="Product/Work">
        <!-- <a-select
          showSearch
          v-decorator="['nama_barang', { rules: [{ required: true }] }]"
        >
          <a-select-option
            v-for="item in getAllProduk"
            :key="item.produk_id"
            :value="item.produk_nm + '-' + item.produk_id"
            >{{ item.produk_nm }}</a-select-option
          >
        </a-select> -->
        <a-input
          v-decorator="[
            'nama_barang',
            {
              rules: [{ required: true }],
            },
          ]"
        ></a-input>
      </a-form-item>
      <a-row :gutter="8">
        <a-col :span="12">
          <a-form-item label="PN">
            <a-input
              v-decorator="[
                'pn_barang',
                {
                  rules: [{ required: true }],
                },
              ]"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="Note">
            <a-input
              v-decorator="[
                'note',
                {
                  rules: [],
                },
              ]"
            ></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="8">
        <a-col :span="12">
          <a-form-item label="Quantity">
            <a-input-number
              :max="10000"
              class="m-width-full"
              v-decorator="['jumlah_barang', { rules: [{ required: true }] }]"
            ></a-input-number>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="Unit">
            <a-auto-complete
              :dataSource="initialSatuan"
              placeholder="input here"
              v-decorator="['satuan', { rules: [{ required: true }] }]"
              :filterOption="handleSatuan"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-form-item :wrapper-col="{ span: 24 }">
        <a-button @click="handleNewItem" block type="primary" html-type="submit"
          >Add</a-button
        >
      </a-form-item>
    </a-row>
    <a-row>
      <a-collapse class="margin-top" activeKey="1">
        <a-collapse-panel key="1">
          <div slot="header">
            <h4 class="margin-remove">Job Details</h4>
          </div>
          <a-list
            itemLayout="vertical"
            :dataSource="listPenjualan"
            :pagination="pagination"
          >
            <Empty
              v-if="listPenjualan ? listPenjualan.length <= 0 : listPenjualan"
            />
            <a-list-item slot="renderItem" slot-scope="item">
              <a-list-item-meta>
                <span slot="title">{{ item.values.nama_barang }}</span>
                <div slot="description" class="margin-remove">
                  <div class="m-display-flex space-between">
                    <span>PN: {{ item.values.pn_barang }}</span>
                  </div>
                  <div class="m-display-flex space-between">
                    <span
                      >Qty: {{ item.values.jumlah_barang }}&nbsp;{{
                        item.values.satuan
                      }}</span
                    >
                  </div>
                  <div class="m-display-flex space-between">
                    <span>Note: {{ item.values.note }}</span>
                  </div>
                  <a-divider class="margin-small" />
                </div>
              </a-list-item-meta>
              <template slot="actions">
                <a-button @click="handleEditModal(item)" type="primary">
                  <a-icon type="edit" />&nbsp;Edit
                </a-button>
                <a-button @click="handleRemove(item)" type="danger">
                  <a-icon type="close" />&nbsp;Remove
                </a-button>
              </template>
            </a-list-item>
          </a-list>
        </a-collapse-panel>
      </a-collapse>
    </a-row>
    <a-modal
      v-model="editModal"
      :key="indexData"
      @cancel="handleCancel"
      :footer="null"
    >
      <span slot="title"> <a-icon type="reload" />&nbsp;Change </span>

      <a-form :form="modalForm">
        <a-form-item label="Produk Name">
          <!-- <a-select
            showSearch
            v-decorator="[
              'nama_barang',
              {
                rules: [{ required: true }],
                initialValue: editData.values.nama_barang,
              },
            ]"
          >
            <a-select-option
              v-for="item in getAllProduk"
              :key="item.produk_id"
              :value="item.produk_nm + '-' + item.produk_id"
              >{{ item.produk_nm }}</a-select-option
            >
          </a-select> -->
          <a-input
            v-decorator="[
              'nama_barang',
              {
                rules: [{ required: true }],
                initialValue: editData.values.nama_barang,
              },
            ]"
          ></a-input>
        </a-form-item>
        <a-row :gutter="8">
          <a-col :span="12">
            <a-form-item label="PN">
              <a-input
                v-decorator="[
                  'pn_barang',
                  {
                    rules: [{ required: true }],
                    initialValue: editData.values.pn_barang,
                  },
                ]"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="Note">
              <a-input
                v-decorator="[
                  'note',
                  {
                    rules: [],
                    initialValue: editData.values.note,
                  },
                ]"
              ></a-input>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="8">
          <a-col :span="12">
            <a-form-item label="Qty">
              <a-input-number
                :min="1"
                :max="10000"
                class="m-width-full"
                v-decorator="[
                  'jumlah_barang',
                  {
                    rules: [{ required: true }],
                    initialValue: editData.values.jumlah_barang,
                  },
                ]"
              ></a-input-number>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="Unit">
              <a-auto-complete
                :dataSource="initialSatuan"
                placeholder="input here"
                v-decorator="[
                  'satuan',
                  {
                    rules: [{ required: true }],
                    initialValue: editData.values.satuan,
                  },
                ]"
                :filterOption="handleSatuan"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-form-item :wrapper-col="{ span: 24 }">
          <a-button
            @click="handleModalEdit"
            block
            type="danger"
            html-type="submit"
            >Change</a-button
          >
        </a-form-item>
      </a-form>
    </a-modal>
  </a-form>
</template>

<script>
import { mapGetters } from "vuex";
import CurrencyFormat from "@/mixins/CurrencyFormat";
export default {
  name: "DetailPenjualan",
  mixins: [CurrencyFormat],
  props: {
    listPenjualan: {},
    mode: String,
  },
  data() {
    return {
      editModal: false,
      editData: {},
      indexData: 0,
      pagination: {
        onChange: (page) => {},
        pageSize: 5,
        size: "small",
      },
      satuan: [],
      editData: [],
      isi_produk: [],
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
    this.modalForm = this.$form.createForm(this);
  },
  computed: {
    ...mapGetters(["getScreen", "getSatuan", "getAllProduk", "getAuth"]),
    initialData() {
      if (this.listPenjualan === undefined || this.listPenjualan.length <= 0) {
        return {
          nama_barang: "",
          jumlah_barang: 0,
          satuan: "",
        };
      } else {
        return {
          nama_barang: this.listPenjualan.nama_barang,
          jumlah_barang: this.listPenjualan.jumlah_barang,
          satuan: this.listPenjualan.satuan,
          note: this.listPenjualan.note,
        };
      }
    },
    initialList() {
      let outputList = [];
      if (this.listPenjualan.length >= 1) {
        outputList = this.listPenjualan;
      }

      return outputList;
    },
    initialSatuan() {
      let satuan = [];
      this.getSatuan.forEach((item) => {
        satuan.push(item["id"]);
      });
      return satuan;
    },
  },
  created() {
    this.$store.dispatch("FETCH_PRODUK");
  },
  mounted() {
    Event.$on("confirmMessageDeleteDetil", this.deleteDetil);
    Event.$on("confirmMessageEditDetil", this.handleModalEditProcess);
  },
  beforeDestroy() {
    Event.$off("confirmMessageDeleteDetil", this.deleteDetil);
    Event.$off("confirmMessageEditDetil", this.handleModalEditProcess);
  },
  methods: {
    handleSatuan(input, option) {
      return (
        option.componentOptions.children[0].text
          .toUpperCase()
          .indexOf(input.toUpperCase()) >= 0
      );
    },
    handleRef() {
      if (this.listPenjualan.length <= 0) {
        this.displayMessage("form-moreData");
      } else {
        Event.$emit("SalesNotifData", { listPenjualan: this.listPenjualan });
      }
    },
    handleNewItem() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        const findName = this.listPenjualan.filter(
          (item) => item.values.nama_barang === values.nama_barang
        );

        if (findName.length > 0) {
          this.displayMessage("form-duplicate");
          return;
        }

        const findPN = this.listPenjualan.filter(
          (item) => item.values.pn_barang === values.pn_barang
        );

        if (findPN.length > 0) {
          this.displayMessage("form-duplicate");
          return;
        }

        let keyIndex = this.listPenjualan.length + 1;
        values = {
          keyIndex: keyIndex,
          nama_barang: values.nama_barang,
          jumlah_barang: values.jumlah_barang,
          satuan: values.satuan,
          pn_barang: values.pn_barang,
          note: values.note,
        };
        Event.$emit("listPenjualan", { values });

        this.form.resetFields();
      });
    },
    handleRemove(item) {
      this.confirmMessageValue("confirm-delete-detil", item);
    },
    deleteDetil(items) {
      console.log(items);
      const newPush = this.listPenjualan.filter(
        (item) => item.values.nama_barang !== items.values.nama_barang
      );
      Event.$emit("UpdateListPenjualan", newPush);
    },
    handleEditModal(item) {
      this.editData = item;
      this.indexData ++;
      this.editModal = !this.editModal;
    },
    handleCancel() {      
      this.editModal = false;
    },
    handleModalEdit() {
      this.modalForm.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        const findName = this.listPenjualan.filter(
          (item) => item.values.nama_barang === values.nama_barang
        );

        if (
          findName.length > 0 &&
          this.editData.values.nama_barang !== values.nama_barang
        ) {
          this.displayMessage("form-duplicate");
          return;
        }

        const findPN = this.listPenjualan.filter(
          (item) => item.values.pn_barang === values.pn_barang
        );

        if (
          findPN.length > 0 &&
          this.editData.values.pn_barang !== values.pn_barang
        ) {
          this.displayMessage("form-duplicate");
          return;
        }

        this.confirmMessageValue("confirm-edit-detil", values);
      });
    },
    handleModalEditProcess(values) {
      const newPush = this.listPenjualan.filter(
        (item) => item.values.nama_barang !== this.editData.values.nama_barang
      );

      values = {
        keyIndex: this.editData.values.keyIndex,
        nama_barang: values.nama_barang,
        jumlah_barang: values.jumlah_barang,
        satuan: values.satuan,
        pn_barang: values.pn_barang,
        note: values.note,
      };

      Event.$emit("UpdateListPenjualan", newPush);
      Event.$emit("listPenjualan", { values });
      this.editModal = !this.editModal;
      this.editData = {
        values: {
          keyIndex: "",
          nama_barang: "",
          jumlah_barang: "",
          satuan: "",
        },
      };
    },
  },
};
</script>

<style>
</style>